// extracted by mini-css-extract-plugin
export default {"root":"MenuDetails_root__jBNSe","details":"MenuDetails_details__RRXZz","delete-icon":"MenuDetails_delete-icon__-Oei+"};